jQuery(document).ready(function ($) {
    const case_study_solution_gallery = new Swiper('.case-study-solution__gallery', {
        loop: true,

        slidesPerView: 1,

        spaceBetween: 20,

        grabCursor: true,

        pagination: {
            el: '.case-study-solution__gallery--pagination',
            type: 'bullets',
            bulletClass: 'pagination__bullet',
            bulletActiveClass: 'active',
            clickable: true
        },

        autoplay: false,
        speed: 500,
    });
});